<template>
    <div>
        <yandex-map
        :settings="settings"
        :coords="coords"
        :zoom="zoom"
        :controls="controls"        
        @map-was-initialized="mapInit"
        
        >
        </yandex-map>
    </div>
</template>
<script>
import { yandexMap } from 'vue-yandex-maps'
import mapSettings from 'src/conf/yandexmap.js';

export default {
    name: 'ReCellMapEditor',
    components: {
        yandexMap
    },
    data(){
        return {
            polygon:null,
            collection:null,
            map:null,
            current: false,
            color: '',
            // masCellOnMap: [],
        };
    },
    props:{
        value:{
            type: String,
            default:'[]'
        },
        /**
         * список дополнительных полигонов
         */
        cells:{
            type: Array,
            default(){ return [
               
            ]},
        },
        /**
         * Настройки карты
         */
        settings:{
            type: Object,
            default(){
                return mapSettings
            }
        },
        /**
         * Координаты стартового центра карты
         */
		coords:{
            type: Array,
            default(){ return [59.93984485554249, 30.314527237792984]},
        },
        /**
         * величина зума (приближения) при её создании
         */

		zoom:{
            type: Number,
            default: 17,
        },
        /**
         * Список активных элементов в карте
         *  */        
		controls:{
            type: Array,
            default(){return ['zoomControl','typeSelector']},
        },
        /**
         * поле означающее что карта не будет редактироваться.
         *  */        
        readonly:{
            type: Boolean,
            default: false,
        }

    },
    watch:{
        value(newValue){
            const current=JSON.stringify(this.polygon.editor.geometry.getCoordinates());
            // console.log(newValue,current);
            if(current==newValue) // Не поменялось
                return;
            let points;
            try{
                points=JSON.parse(newValue);
            }catch(e){
                points=[];
            }
            this.polygon.editor.geometry.setCoordinates(points);
        },
        cells(newValue){
            // console.log('cells',newValue);
            this.drawCells();
        },
        readonly(newValue){
            // console.log('radonly', this.readonly, newValue);
            if(!newValue) this.startEdit();
            else this.stopEdit();
        }
    },
    methods:{
        /**
         * Включение режима редактирования.
         * center - логический, нужно ли центировать карту на редактируемом полигоне
         *  */ 
        startEdit(center){
            // console.log('radonly', this.readonly);
            if(this.readonly) return false;
            setTimeout(()=>{
                this.polygon.editor.state.set('drawing',true)
                center&&this.zoomMap();
            },1);
        },
        /**
         * Прекращает редактирование если прилетело значение
         */
        stopEdit(center){
            this.polygon.editor.state.set('drawing',false)
        },
        /**
         * центрирование карты на пришедшем полигоне
         * cellValues - текстовая строка с точками полигона.
         */
        focus(cellValues){
            try{
                let bounds;
                let polygon=JSON.parse(cellValues)
                if(polygon.length==1){ // 1 контур
                    polygon[0].forEach(coord=>{
                        if(!bounds)
                            bounds=[[...coord], [...coord]]
                        bounds=[
                            [
                                Math.min(bounds[0][0],coord[0]),
                                Math.min(bounds[0][1],coord[1]),
                            ],[
                                Math.max(bounds[1][0],coord[0]),
                                Math.max(bounds[1][1],coord[1]),
                            ]
                        ]
                    })
                    this.map.setBounds(bounds,{
                        duration:500,
                        zoomMargin:[100,500],
                    })    
                }
            }catch(e){
                return false;
            }
        
        },
        /**
         * Зуммирует карту на редактируемом полигоне
         */
        zoomMap(){
            this.map.setBounds(this.polygon.editor.geometry.getBounds(),{
                duration:500,
                zoomMargin:[100,500],
            })
        },
        // zoomMap(cellValues){
        //     let polygon=JSON.parse(cellValues)
        //     this.map.setBounds(polygon.editor.geometry.getBounds(),{
        //         duration:500,
        //         zoomMargin:[100,500],
        //     })
        // },
        /**
         * перерисовка вторичныхполигонов на карте
         */
        drawCells(){
            if(!this.map) return;
            this.map.geoObjects.remove(this.collection);
            this.collection.removeAll();

            this.cells.forEach(cell=>{
                try{
                    cell.cellValues &&
                    this.collection.add(new ymaps.Polygon(
                        JSON.parse(cell.cellValues),
                        {
                            hintContent:cell.id+': '+cell.cellName,
                            balloonContentHeader:'Сота '+cell.id,
                            balloonContentBody:cell.cellName
                        },cell.cellStyle||{
                            fillColor: '#00BF9A40',
                            strokeColor: '#0000FF',
                            strokeWidth: 1,
                        }
                    ))
                }catch(e){
                    console.error(e,cell.cellValues);
                }
            })
            this.map.geoObjects.add(this.collection);
        },
        /** 
         * принудительное обновление данных в моделе, по текущему полигону.
         */
        saveData(){
            if(this.polygon)
                this.$emit('input',JSON.stringify(this.polygon.editor.geometry.getCoordinates()));
        },
        /**
         * инициализация карты после создания
         */
        mapInit(myMap){
            const me=this;
            this.map=myMap;
            var coords=JSON.parse(this.value)
            this.collection=new ymaps.GeoObjectCollection({},{});

            var polygon = new ymaps.Polygon(coords, {
                
            }, {
                editorDrawingCursor: "crosshair",
                fillColor: '#00FF0040',
                strokeColor: '#0000FF',
                strokeWidth: 3,
               
            });
            this.polygon=polygon;
            if(!this.readonly){

                
                polygon.editor.options.set('addInteriors',false);
                polygon.editor.options.set('menuManager',function(list,model){
                    list.push({
                        id:'clearAll',
                        title:'Очистить всё',
                        onClick(){
                            polygon.editor.geometry.setCoordinates([])
                            //me.value='[]';
                            me.startEdit();
                        }
                    })
                    return list;
                })
                polygon.editor.events.add(['vertexadd','vertexdraw','vertexdragend','statechange'],(event)=>{
                    this.saveData();
                });
                setTimeout(()=>polygon.editor.startDrawing(),10)
                
            }else{ console.error('READONLY');
            }

            myMap.geoObjects.add(polygon);

            this.drawCells();
        },

    },
    mounted() {
	}
}
</script>
